import axios from 'axios'
import auth from '../auth/initAuth'
import store from '../store'

const login = async (
  email,
  password,
  page,
  captcha,
  valorCaptcha,
  tipoSistema
) => {
  axios
    .post(process.env.URL_API_BASE + '/sistema-usuario/login', {
      email,
      password,
      sistema: 1,
      captcha,
      valorCaptcha,
      tipoSistema
    })
    .then(response => {
      if (response.data.user) {
        localStorage.setItem('user', JSON.stringify(response.data.user))

        auth.login(email, password, (err, authResult) => {
          if (err) {
            localStorage.removeItem('user')
            localStorage.removeItem('jwt')

            if (err.error && err.error === 'access_denied') {
              page.messages = 'Login ou senha incorretos'
            } else {
              page.messages = 'Erro ao efetuar login'
            }
          }
          page.onLoaded()
        })
      }
    })
    .catch(() => {
      page.messages = 'Login ou senha incorretos'
      page.showModalLoader = false
    })

  return true
}

const logout = () => {
  localStorage.removeItem('user')
  localStorage.removeItem('jwt')
  localStorage.removeItem('expires_login')
  localStorage.removeItem('AUTH_CLIENT_ID')
  localStorage.removeItem('AUTH_DOMAIN')
  localStorage.removeItem('AUTH_CONNECTION_DB_BACKOFFICE')
  localStorage.removeItem('BACKOFFICE_LOGIN_EXPIRES')

  store.commit('setAuthenticated', false)

  window.location = '/'
}

const isAuthenticated = () => {
  return getToken() != null
}

const getToken = () => {
  return localStorage.getItem('jwt')
}

const recuperarSenha = async (email, currentUrl, page) => {
  axios
    .post(process.env.URL_API_BASE + '/sistema-usuario/recuperar-senha', {
      email: email,
      url: currentUrl,
      sistema: 1
    })
    .then(response => {
      if (response.data.isOk) {
        page.success = true
        page.messages =
          'Você receberá um email com as informações para recuperar sua senha!'
        page.email = ''
      } else {
        page.success = false
        page.messages = 'Email não identificado'
      }
      page.onLoaded()
    })
}

const atualizarSenha = async (email, senha, token) => {
  let AUTH_CONNECTION_DB_BACKOFFICE =
    localStorage.getItem('AUTH_CONNECTION_DB_BACKOFFICE')

  return axios
    .post(process.env.URL_API_BASE + '/sistema-usuario/atualizar-senha', {
      email: email,
      senha: senha,
      token: token,
      connection: AUTH_CONNECTION_DB_BACKOFFICE
    })
}

const getUsuario = () => {
  return JSON.parse(localStorage.getItem('user'))
}

export default {
  login,
  logout,
  isAuthenticated,
  getToken,
  recuperarSenha,
  atualizarSenha,
  getUsuario
}



// WEBPACK FOOTER //
// ./src/actions/LoginActions.js